'use client';

import { type KeyboardEvent, type RefObject, useCallback } from 'react';

export const FOKUSSIERBAR =
  'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]):not([tabindex="-1"]), iframe, [tabindex]:not([tabindex="-1"])';

/**
 * Fokus-Falle der Website-Fenster: Esc schließt, Tab und Umschalt+Tab kreisen
 * innerhalb von `flaecheRef`. Herausgelöst aus dem Buchungsfenster
 * (Spec 2026-10-12 §6), benutzt dort und vom Newsletter-Banner.
 *
 * Liefert den `onKeyDown`-Handler für das Fenster-Element. Anfangsfokus und
 * Rückgabe des Fokus regelt das jeweilige Fenster selbst.
 */
export function useFokusFalle(
  flaecheRef: RefObject<HTMLElement | null>,
  schliessen: () => void,
) {
  return useCallback(
    (event: KeyboardEvent<HTMLElement>) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        schliessen();
        return;
      }

      if (event.key !== 'Tab') return;

      const flaeche = flaecheRef.current;
      if (!flaeche) return;

      const fokussierbar = Array.from(
        flaeche.querySelectorAll<HTMLElement>(FOKUSSIERBAR),
      );
      if (fokussierbar.length === 0) return;

      const erstes = fokussierbar[0]!;
      const letztes = fokussierbar[fokussierbar.length - 1]!;
      const aktiv = document.activeElement;

      if (event.shiftKey) {
        if (aktiv === erstes || !flaeche.contains(aktiv)) {
          event.preventDefault();
          letztes.focus();
        }
      } else if (aktiv === letztes || !flaeche.contains(aktiv)) {
        event.preventDefault();
        erstes.focus();
      }
    },
    [flaecheRef, schliessen],
  );
}
